import {Component, OnInit} from '@angular/core';
import {ModalDialogV3} from '../../models/modal-dialog-v3';
import {InfoModalModel} from '../../models/info-modal-model';
import {InfoModalResultModel} from '../../models/info-modal-result-model';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrl: './info-modal.component.scss',
    standalone: false
})
export class InfoModalComponent extends ModalDialogV3 implements OnInit {

    public model: InfoModalModel;

    public static readonly ButtonTypeEnum = {
        FILLED: 'FILLED',
        TEXT: 'TEXT',
    };
    public ButtonTypeEnum = InfoModalComponent.ButtonTypeEnum;

    public static readonly ActionEnum = {
        CONFIRM: 'CONFIRM',
        CANCEL: 'CANCEL',
        CLOSE: 'CLOSE',
    };
    public ActionEnum = InfoModalComponent.ActionEnum;


    constructor() {
        super();
    }

    ngOnInit(): void {
        this.model = this.modalParams['model'] as InfoModalModel;
    }

    onDialogCancelBtnClicked() {
        this.announceModelChanged({
            action: undefined,
            buttonType: undefined,
            buttonLabel: 'X',
        } as InfoModalResultModel);
        super.close();
    }

    onConfirmBtnClicked() {
        this.announceModelChanged({
            action: this.ActionEnum.CONFIRM,
            buttonType: this.ButtonTypeEnum.FILLED,
            buttonLabel: this.model.confirmButtonLabel,
        } as InfoModalResultModel);
        super.close();
    }

    onCancelBtnClicked() {
        this.announceModelChanged({
            action: this.ActionEnum.CANCEL,
            buttonType: this.ButtonTypeEnum.TEXT,
            buttonLabel: this.model.cancelButtonLabel,
        } as InfoModalResultModel);
        super.close();
    }

    onBackdropClicked(event: MouseEvent) {
        if (event.target === event.currentTarget) {
            this.announceModelChanged({
                action: undefined,
                buttonType: undefined,
                buttonLabel: 'backdrop',
            });
            super.close();
        }
    }
}

